import { envConfigs } from '../../../envConfigs';
import { lionSelectors } from '@rosetta/react-lion';
import { ltrDir, rtlDir } from '../constants';

/**
 * allInterfaceLanguages()
 *  returns an array of language objects representing all the possible interface languages
 */
export const allInterfaceLanguages = () => {
  let allLangs = [
    { value: 'ar-SA', products: ['SEU'], dir: rtlDir, nativeName: 'االعربية' },
    { value: 'de-DE', products: ['all', 'SEU'], dir: ltrDir, nativeName: 'Deutsch', locale: 'de' },
    { value: 'en-US', products: ['all', 'SEU'], dir: ltrDir, nativeName: 'English', locale: 'en' },
    { value: 'es-419', products: ['all', 'SEU'], dir: ltrDir, nativeName: 'Español', locale: 'es-419' },
    { value: 'fa-IR', products: ['SEU'], dir: rtlDir, nativeName: 'فارسى' },
    { value: 'fr-FR', products: ['all', 'SEU'], dir: ltrDir, nativeName: 'Français', locale: 'fr' },
    { value: 'hi-IN', products: ['SEU'], dir: ltrDir, nativeName: 'हिंदी' },
    { value: 'id-ID', products: ['all', 'SEU'], dir: ltrDir, nativeName: 'Bahasa Indonesia' },
    { value: 'it-IT', products: ['all'], dir: ltrDir, nativeName: 'Italiano', locale: 'it' },
    { value: 'nl-NL', products: ['all'], dir: ltrDir, nativeName: 'Nederlands' },
    { value: 'pl-PL', products: ['all'], dir: ltrDir, nativeName: 'Polski' },
    { value: 'pt-BR', products: ['all', 'SEU'], dir: ltrDir, nativeName: 'Português', locale: 'pt' },
    //{ value: 'pt-BR', products: ['all', 'SEU'], dir: ltrDir, nativeName: 'Português (Brasil)' },
    //{ value: 'pt-PT', products: ['all', 'SEU'], dir: ltrDir, nativeName: 'Português (Portugal)' },
    { value: 'ja-JP', products: ['all', 'SEU'], dir: ltrDir, nativeName: '日本語' },
    { value: 'ko-KR', products: ['all', 'SEU'], dir: ltrDir, nativeName: '한국어' },
    { value: 'ru-RU', products: ['all', 'SEU'], dir: ltrDir, nativeName: 'Русский' },
    { value: 'sw-TZ', products: ['SEU'], dir: ltrDir, nativeName: 'Kiswahili' },
    { value: 'tr-TR', products: ['SEU'], dir: ltrDir, nativeName: 'Türkçe' },
    { value: 'ur-PK', products: ['SEU'], dir: rtlDir, nativeName: 'اردو' },
    { value: 'vi-VN', products: ['all', 'SEU'], dir: ltrDir, nativeName: 'Tiếng Việt' },
    { value: 'zh-CN', products: ['all', 'SEU'], dir: ltrDir, nativeName: '中文' }
  ];
  if (envConfigs.dev) {
    allLangs.push({
      value: 'xx-XX',
      products: ['all', 'SEU'],
      dir: ltrDir,
      nativeName: 'Pseudo-loc'
    });

    // DEV ONLY RTL and only for developing for RTL UI
    // let arabicLang = allLangs.find((aLang) => {
    //   return aLang.value === 'ar-SA';
    // });
    // arabicLang.products = ['SEU', 'all'];
    // end RTL dev code
  }
  return allLangs;
};

export function getLearnerSelectLearningLanguages(state) {
  let localizedLearningLanguages = [];

  function addLanguageItem(languageCode, nameKey) {
    const languageLabel = lionSelectors.getLionTranslatedString(state, nameKey);
    localizedLearningLanguages.push({ value: languageCode, label: languageLabel });
  }

  addLanguageItem('ar', '_language_ar');
  addLanguageItem('zh-CN', '_language_zh-CN');
  addLanguageItem('nl-NL', '_language_nl-NL');
  addLanguageItem('en-US', '_language_en-US');
  addLanguageItem('en-GB', '_language_en-GB');
  addLanguageItem('tl-PH', '_language_tl-PH');
  addLanguageItem('fr-FR', '_language_fr-FR');
  addLanguageItem('de-DE', '_language_de-DE');
  addLanguageItem('el-GR', '_language_el-GR');
  addLanguageItem('he-IL', '_language_he-IL');
  addLanguageItem('hi-IN', '_language_hi-IN');
  addLanguageItem('ga-IE', '_language_ga-IE');
  addLanguageItem('it-IT', '_language_it-IT');
  addLanguageItem('ja-JP', '_language_ja-JP');
  addLanguageItem('ko-KR', '_language_ko-KR');
  addLanguageItem('fa-IR', '_language_fa-IR');
  addLanguageItem('pl-PL', '_language_pl-PL');
  addLanguageItem('pt-BR', '_language_pt-BR');
  addLanguageItem('ru-RU', '_language_ru-RU');
  addLanguageItem('es-419', '_language_short_es-419');
  addLanguageItem('es-ES', '_language_es-ES');
  addLanguageItem('sv-SE', '_language_sv-SE');
  addLanguageItem('tr-TR', '_language_tr-TR');
  addLanguageItem('vi-VN', '_language_vi-VN');

  return localizedLearningLanguages;
}

export const getAvailableInterfaceLanguages = () => {
  let availableUILangs = [];
  const productFilter = 'all';
  allInterfaceLanguages().forEach(function(langObj) {
    if (langObj.products.indexOf(productFilter) !== -1) {
      availableUILangs.push(langObj);
    }
  });
  return availableUILangs;
};

export const isValidInterfaceLanguage = (isoCode) => {
  if (!isoCode) {
    return false;
  }
  const langObj = getAvailableInterfaceLanguage(isoCode);
  return typeof langObj !== 'undefined';
};

export const getAvailableInterfaceLanguage = (isoCode) => {
  const langObj = getAvailableInterfaceLanguages().find((aLangObj) => {
    return aLangObj.value === isoCode;
  });
  return langObj;
};

// getInterfaceLanguage() will retrieve the language
//  object even if it is not available to this product
export const getInterfaceLanguage = (isoCode) => {
  const langObj = allInterfaceLanguages().find((aLangObj) => {
    return aLangObj.value === isoCode;
  });
  return langObj;
};

export const isEndangeredLanguage = (isoCode) => {
  const endangeredLanguages = ['cic', 'lui', 'oji'];

  if (!isoCode) {
    return false;
  }
  return endangeredLanguages.includes(isoCode);
};

export const getSupportLocale = (loc) => {
  // This is for the URL: https://support.rosettastone.com/s/?language=
  // If the language code is not recognized by support, then they default to en-US
  if (!loc || loc==='en-US'){
    return 'en_US';  // Language_Local: English, USA
  }
  if (loc==='nl-NL'){
    return 'nl_NL'; // Language_Local: Duch, Netherlands
  }
  if (loc==='pt-BR'){
    return 'pt_BR'; // Language_Local: Portuguese, Brazil
  }
  if (loc==='zh-CN'){
    return 'zh_CN'; // Language_Local: Chinese, simplified
  }
  if (loc==='id-ID'){
    return 'in';  // Non-standard 2 character language code (id -> in)
  }
  // Note that vi-VN is not currently supported at support.rosettastone.com, so it defaults to en-US.
  // We will continue to send support.rosettastone.com the vi language code in case one day it does support Vietnamese...
  return loc.slice(0, 2); // Return first 2 characters (language only)
}



// WEBPACK FOOTER //
// ./src/modules/app/services/language-helpers.js